var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSrs = function SvgSrs(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 10.6224C22.6637 8.1982 21.5412 5.95199 19.8054 4.22979C18.0695 2.5076 15.8167 1.40497 13.3938 1.09176C10.9709 0.778548 8.51248 1.27213 6.39715 2.49646C4.28182 3.7208 2.62697 5.60797 1.6875 7.86728M1 2.35699V7.86728H6.5M1 13.3776C1.33627 15.8018 2.45878 18.048 4.19462 19.7702C5.93046 21.4924 8.18334 22.595 10.6062 22.9082C13.0291 23.2215 15.4875 22.7279 17.6028 21.5035C19.7182 20.2792 21.373 18.392 22.3125 16.1327M23 21.643V16.1327H17.5",
    stroke: "#E5B42F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSrs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/srs.dd61fc7371a5dad6f7fc0260f0b15f75.svg";